var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: props.fill,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6723 26.5724C45.8294 23.0879 46.5313 18.7709 45.593 14.7569C43.5884 5.6136 32.4879 1.87741 25.5734 8.00473C25.0259 8.48675 24.5389 9.04247 24 9.59658C23.4612 9.04248 22.9741 8.48675 22.4266 8.00473C15.5121 1.87741 4.41161 5.6136 2.407 14.7569C1.46876 18.7709 2.17054 23.0879 4.3277 26.5724C8.10241 32.6795 14.189 37.435 20.1264 41.7447C22.4322 43.4184 25.5679 43.4184 27.8737 41.7447C33.8111 37.435 39.8976 32.6795 43.6723 26.5724Z"
  })));
};
export default SvgHeart;